import CityPage from "../CityPage";

export default function Bolingbrook() {
  return <CityPage slug="bolingbrook" />;
}
